{
    "_hasAlreadyBeenAdded": "has already been added",
    "_isNotAValidEmailAddress": "is not a valid email address",
    "actionNotAllowed": "Action not allowed",
    "allowedMinutesAre": "Allowed minutes are {{minutes}}",
    "answerRequired": "An answer is required",
    "anyCodesHasBeenImportedTheyAreAllRepeated": "No codes have been imported because they are all repeated.",
    "cannotCreateSessions": "Sessions cannot be created",
    "cannotDeactivateYourOwnAccount": "You can't deactivate your own account",
    "cannotDownloadImage": "Image cannot being downloaded",
    "cannotLoadImage": "Image cannot being loaded",
    "cannotSaveImage": "Image cannot being saved",
    "cannotSaveSessions": "Sessions cannot be saved",
    "cannotUploadFile": "File cannot being uploaded",
    "cannotUploadImage": "Image cannot being uploaded",
    "configSessionsMoreThanSixMonthsError": "It is not allowed to configure sessions for more than 6 months",
    "dateMax": "The date must be at earlier than {{maxDate}}",
    "dateMaxBeforeSessionDatetime": "The date must be at earlier than session date",
    "dateOutRange": "The selected date is out of the defined effective date range",
    "defaultErrorTryAgainLater": "An error has occurred. Try again later.",
    "email": "Invalid email",
    "emailTemplateMustBeSelected": "You must select an Email template",
    "endAt": "End date must be after the start date.",
    "endDateMustBeGreaterThanStartDate": "\"End\" date must be greater than \"Start\" date",
    "errorUpdatingDiscountCodes": "Error updating discount codes",
    "eventCannotBePublished": "Unable to publish event. Data still needs to be filled in:",
    "heightDifference": "Image width must be {{difference}}px less than the height",
    "heightExceeded": "Image height must be less than {{height}}px",
    "heightMin": "Image height must be bigger than {{height}}px",
    "invalid": "Invalid",
    "invalidEmails": "Invalid emails: {{emails}}",
    "invalidTemplateType": "Invalid template type",
    "languageIsMissing": "{{language}} is missing",
    "length": "Invalid",
    "lengthArrayMax": "It must be no more than {{count}}",
    "lengthArrayMin": "It must be at least {{count}}",
    "lengthMax_one": "It must be no more than {{count}} character long",
    "lengthMax_other": "It must be no more than {{count}} characters long",
    "lengthMin_one": "It must be at least {{count}} character long",
    "lengthMin_other": "It must be at least {{count}} characters long",
    "maxRepeatedCodesTry": "Attempts to generate random codes have been successful. Try changing the prefix or code size.",
    "mustBeTheSamePassword": "Must be the same password",
    "nExactly": "Must be {{number}} characters",
    "nOrLess": "Must be {{number}} characters or less",
    "nOrMore": "Must be {{number}} characters or more",
    "nif": "Invalid",
    "noCompany": "The user has no company",
    "noPermissionsToViewCapabilities": "You do not have permissions to view the capabilities",
    "notHavenAvailableCodes": "No new code to import",
    "pdfIsNotAllowed": "PDF is not allowed",
    "pdfTemplateMustBeSelected": "You must select a PDF template",
    "permissionDenied": "You do not have the required permissions for this action.",
    "phone": "Invalid phone number",
    "positiveNonZero": "Must be greater than zero",
    "positiveNumberAsString": "Please enter a valid number",
    "previewError": "Error performing the preview",
    "request": "Something has gone wrong",
    "required": "Required",
    "requiredAtLeastOneEmail": "You must enter at least one email",
    "requiredAtLeastOneRecipient": "You must select at least one recipient",
    "requiredAtLeastOneSession": "You must select at least one session",
    "requiredAtLeastOneSubscriber": "You must select at least one subscriber",
    "requiredEvent": "You must select an event",
    "requiredIfNoByAction": "Required if not present \"By action\"",
    "requiredIfNoDailyAt": "Required if not present \"Specific time\"",
    "requiredIfNoEvents": "Required if not select an \"Event\"",
    "requiredIfNoFinishByAction": "Required if not present \"Close by action\"",
    "requiredIfNoFinishByHour": "Required if not present \"Close by time\"",
    "requiredIfNoStatus": "Required if not select \"Status events\"",
    "requiredSubscriber": "You must select a subscriber",
    "requiredWhenNoAllSpecificRecipients": "Required when there is no \"Specific recipients\"",
    "requiredWhenNoGenericRecipients": "Required when there is no \"Generic recipients\"",
    "requiredWithDailyAt": "Required with \"Specific time\"",
    "requiredZone": "You must select a zone",
    "startAt": "Start date must be before the end date.",
    "statusChangeForbidden": "State change not allowed",
    "subscriberNotFoundWithEmail": "Subscriber not found with email: {{emails}}",
    "templateMustBeSelected": "You must select a template",
    "thisType": "Specify one of the following types: {{types}}",
    "ticketCodeTypeGenerateRequirement": "Nº of codes and Nº of characters are mandatory fields",
    "ticketHoursInvalid": "The end time must be greater than the start time",
    "ticketHoursRequired": "You must select a time slot",
    "ticketWindowRequired": "You must select a ticket office hours",
    "ticketsConfigurationUpdateError": "Error updating tickets configuration",
    "toGenerateCodesUseGenerateButton": "To generate codes, use the generate button",
    "typeAlphaNonNumeric": "Can only be letters",
    "typeNumber": "Value should be a number",
    "url": "Invalid URL",
    "widthExceeded": "Image width must be less than {{width}}px",
    "youHaveReachedTheLimitOfEmails": "You have reached the limit of emails",

    "Company with id was not found": "Company with id \"{{uuid}}\" was not found",
    "Event with id was not found": "An event with id \"{{uuid}}\" was not found",
    "Invalid UUID string": "Invalid UUID string \"{{uuid}}\"",
    "Operation cancelled due to cart deletion.": "Operation cancelled due to cart deletion.",
    "Operation cancelled due to payment being abandoned over time.": "Operation cancelled due to payment being abandoned over time.",
    "Operation cancelled. The user does not wish to continue.": "Operation cancelled. The user does not wish to continue.",
    "Operation paid after being canceled.": "Operation paid after being canceled.",
    "Order is in a wrong status.": "Order is in a wrong status.",
    "Payment attempt abandoned due to new payment generation.": "Payment attempt abandoned due to new payment generation.",
    "Template with id was not found": "Template with id \"{{uuid}}\" was not found",
    "The user credentials were incorrect.": "Incorrect user name or password",
    "There are not enough tickets to complete the operation.": "There are not enough tickets to complete the operation.",
    "productionCompany You don't have permission to carry out operations in events with a company different from yours": "You don't have permission to view the event details",

    "AnyDiscountNoExist": "Some of the selected discount codes do not exist",
    "CannotAssignNewAgentAlreadyExist": "There is an agent already assigned to this issue",
    "CannotChangeStatusByConditions": "You cannot change status with the current conditions",
    "CannotChangeTypeIndividual": "Cannot change the type of subscription to individual",
    "CannotDeleteASessionWithSoldTickets": "Cannot delete a session with sold tickets",
    "CannotDeleteAnActiveDiscountCode": "Cannot delete an active discount code or with associated subscription",
    "CantPublishWithoutWebsiteMinInfo": "Website is required to be filled",
    "ChangeTicketCodeTypeNotPermittedSessionWithSales": "You cannot change the type of ticket generation when there are tickets sold",
    "CommercialUserNotAllowedToAssignToDiscount": "The agent does not have permissions to assign this discount",
    "DirectAccessTypeNotProcessableWithTicketCodeType": "Direct access type is not compatible with ticket code type",
    "DirectAccessTypeNotProcessableWithTicketFormat": "Direct access type is not compatible with ticket format",
    "DuplicateCodeFound": "Duplicate code found",
    "EmailNotFound": "Email not found",
    "EmailsNotFound": "Emails must be from existing users",
    "EnclosureAlreadyExists": "An enclosure already exists with the name entered",
    "EnclosureHasEventsAssociatedItCannotBeDeleted": "The enclosure has associated events and cannot be removed",
    "ErrorRequestToGateway": "Error when making request to payment gateway",
    "EventFeaturedLimitExceeded": "The limit of featured has been reached",
    "EventHasCompletedOrders": "The event has already sold tickets",
    "ForbbidenUpdateStartAtWhenExistsOtherSessionWithSameDate": "Date cannot be changed because there is already another session with the same datetime",
    "ForbbidenUpdateStartAtWhenFinalizeOrCanceled": "Date cannot be changed when session is finished or cancelled",
    "ForbbidenUpdateStartAtWhenSessionFinishAtIsAfter": "Date cannot be changed because finish-at time is greater than session time",
    "ForbiddenChangeStatusToPublished": "You do not have permission to change to published",
    "ForbiddenCreateEventByStatus": "You do not have permission to create an event with this status",
    "ForbiddenMakeModificationsByStatus": "You do not have permission to make modifications with this status",
    "ForbiddenMakeUpdatePrices": "You do not have permission to make modifications to prices",
    "IncompatibleTicketFormatAndTicketCodeType": "Incompatible ticket format and ticket code type",
    "IncorrectEventSessionIndividualZonesCapacity": "The capacity of a session's individual zones cannot exceed the venue's capacity",
    "IncorrectEventSessionZoneCapacity": "The capacity of a session's zone cannot exceed the venue's capacity",
    "IncorrectEventZoneCapacity": "The capacity of an event's zone cannot exceed the venue's capacity",
    "IncorrectFinishSessionTime": "The session closing time cannot be later than the start time",
    "IncorrectStartSession": "A session cannot be repeated on the same day at the same start time",
    "InsufficientAmountCodesForSelectedSessions": "Insufficient number of codes for selected sessions",
    "InvalidCredentials": "Invalid credentials",
    "InvalidCsv": "Invalid CSV",
    "LimitUsagesNotMustBeLessThanMaxTotalUses": "The limit of uses cannot be less than the current total uses",
    "MaxRepeatedCodesTry": "Attempts to generate random codes have been successful. Try changing the prefix or code size.",
    "MessageShort": "You must enter a message of at least 2 characters",
    "NetworkError": "Network error: API is not accessible from this network.",
    "NoAllowEmptyContent": "You must complete the content of the template",
    "NoCodesAvailable": "Not enough ticket codes",
    "NoCodesForSelectedSessions": "There are no codes for the selected sessions",
    "NoPublishEventByTotalAvailableTicketsCodes": "The event cannot be published due to lack of ticket codes",
    "NoPublishSessionByTotalAvailableTicketsCodes": "The session cannot be published due to lack of ticket codes",
    "NoSelectedSessions": "No sessions selected",
    "NotChangeEnclosureWhenEventHasOrders": "Enclosure cannot be changed because the event has already sold tickets",
    "NotChangeTicketInfoWhenEventHasSessions": "Cannot change ticket format when event has sessions",
    "NotChangeTicketTypeWhenEventHasSessions": "Cannot change ticket type when event has sessions",
    "NotEnoughCodesForAllSessionsSelected": "There are not enough codes for all the selected sessions",
    "NotEnoughCodesForAnySelectedSessions": "There are not enough codes for any of the selected sessions",
    "NotEnoughCodesToPrereserve": "There are not enough codes to prereserve",
    "NotFoundAbonoCompany": "Subscription company not found",
    "NotFoundTemplateByTypeAndSession": "Template not found by type and session",
    "NotFoundUser": "User not found",
    "OnlineTicketTypeNotProcessableWithTicketCodeType": "Online ticket type is not compatible with ticket code type",
    "OnlineTicketTypeNotProcessableWithTicketFormat": "Online ticket type is not compatible with ticket format",
    "OnlyCsvFilesAreAllowed": "Only CSV files are allowed",
    "OperationNoActionChecked": "No action has been selected",
    "OperationNoDataForAnySubscription": "There is no data for any subscription",
    "OperationNotFound": "Operation does not exist",
    "OperationNothingHasBeenChecked": "No options (checks) have been selected for the operation request.",
    "OperationOrderHasNoTickets": "The operation has no associated tickets",
    "OperationOrderPaidAfterEditInOtherDevice": "The order is incorrect because the payment is pending in Redsys, but it has been modified from another tab or device",
    "OperationRefundError": "Error in refund with payment service",
    "OperationResendIpmessengerError": "Error when resending with messaging service",
    "OperationUnitsExceeded": "The number of units for the operation has been exceeded",
    "OperationUnknownError": "Operation unknown error",
    "OrderHasNoSubscriptions": "The order has no subscriptions",
    "OrderHasNotPaymentId": "The order has no payment ID",
    "OrderIsNotAPurchaseSubscription": "The operation is not a subscription purchase",
    "OrderIsNotATicket": "The operation is not a ticket",
    "OrderNotRefund": "The order cannot be refunded",
    "OrderTypeNotValid": "The order type is not valid",
    "OtherTicketWindowInvalidWithoutTicketHours": "Other ticket window is invalid without ticket hours",
    "ParentOperationMustBeGenericTypeSubscription": "The parent operation must be of generic subscription type",
    "ParentOperationMustBeTypeSubscriptionBuy": "The parent operation must be of type subscription purchase",
    "ParentOperationMustBeTypeTicketBuy": "The parent operation must be of type ticket purchase",
    "RequiredFinishSessionTime": "You must specify a session closing time",
    "RequiredMarketHeader": "Market not specified in the request header",
    "RequiredTokenUserId": "Token or user id required",
    "SessionMailWithPdfNotPdfType": "The session does not have a PDF template associated",
    "SessionRequireTemplateEmail": "Cannot publish the session because it does not have an email template",
    "SessionWithoutTicketConfiguration": "The session cannot be published because it does not have ticket configurations",
    "SomeDiscountNotOfIndicatedType": "Some of the selected discount codes are not of the indicated type",
    "SomeSubscriptionDatesOverlap": "Dates cannot overlap",
    "SubscriptionTypeHasSubscriptions": "Cannot delete a subscription type with associated subscriptions",
    "TemplateForSessionIsNotPdfType": "The session template is not in PDF type",
    "TemplateNotFound": "Template doesn't exist",
    "TheCapacityCannotBeLessThanTheTotalNumberOfTicketsSold": "The capacity cannot be less than the total number of tickets sold",
    "TicketCodeTypeNotImportable": "Some of the selected sessions are not configured for code import",
    "TicketOfficeTypeNotProcessableWithTicketCodeType": "Ticket office type is not compatible with ticket code type",
    "TicketOfficeTypeNotProcessableWithTicketFormat": "Ticket office type is not compatible with ticket format",
    "UnknownError": "There seems to have been an unknown error. Please try again later.",
    "UserWithoutPassword": "User pending to update their password"
}
